import React from 'react'
import { useAppStore } from '@/hooks/useAppStore'
import type { Screen } from '@/types'

interface TopbarProps {
  center?: React.ReactNode
  backTo?: Screen
  backLabel?: string
}

export function Topbar({ center, backTo, backLabel = '← Back' }: TopbarProps) {
  const setScreen = useAppStore((s) => s.setScreen)
  return (
    <header style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 20px', background: 'rgba(36,18,9,0.92)', borderBottom: '1px solid rgba(212,160,23,0.18)',
      position: 'sticky', top: 0, zIndex: 20, backdropFilter: 'blur(6px)',
    }}>
      {/* Brand */}
      <div>
        <div style={{ fontFamily: 'var(--serif-caps)', fontSize: 16, letterSpacing: '0.14em', color: 'var(--gold2)', textTransform: 'uppercase' }}>
          Passage
        </div>
        <div style={{ fontFamily: 'var(--sans)', fontSize: 9, color: 'rgba(196,149,106,0.65)', letterSpacing: '0.1em', marginTop: -2 }}>
          by Imaginarium
        </div>
      </div>
      {/* Center */}
      {center && <div style={{ fontFamily: 'var(--serif-caps)', fontSize: 10, color: 'var(--warm)', letterSpacing: '0.1em' }}>{center}</div>}
      {/* Back */}
      {backTo ? (
        <button onClick={() => setScreen(backTo)} style={{
          fontFamily: 'var(--serif-caps)', fontSize: 10, letterSpacing: '0.08em', color: 'var(--warm)',
          background: 'transparent', border: '1px solid rgba(196,149,106,0.3)', padding: '5px 12px', cursor: 'pointer',
        }}>{backLabel}</button>
      ) : <div style={{ width: 60 }} />}
    </header>
  )
}
